import styled from 'styled-components';

export const StyledSuccessEditPassword = styled.div`
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;

    @media only screen and (max-width: 926px) {
        margin-top: 0;
        height: auto;

        > h3 {
            font-size: 34px;
        }
    }
`;
